<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div  class="btn-box">
        <el-date-picker v-model="timeValue" size="small" type="datetimerange" @change="changeTimeValue"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <input-select selectTitle="报警状态" :selectKey="'alarmStatus'" :selectData="alarmStatusList" @search="search" style="margin-left: 10px;"/>
        <input-select selectTitle="报警类型" :selectKey="'deviceType'" :selectData="deviceTypeList" @search="search" style="margin-left: 10px;"/>
      </div>

      <!--<div class="btn-box">-->
        <!--<input-select selectTitle="设备状态" :selectKey="'deviceChangeStatus'" :selectData="deviceChangeStatusList" @search="search"/>-->
      <!--</div>-->

      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="设备名称" @search="searchKey" />
        <!--<button-export-->
        <!--:href="exportUrl"-->
        <!--download="download.xls"-->
        <!--:beforeDownload="beforeDownload"-->
        <!--value="导出"/>-->
      </div>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/FireControl";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "fire-control-call-police-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧消防",
          name: "fire-over-view"
        },
        {
          value: "报警记录"
        }
      ],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      exportUrl: "",
      deviceChangeStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "在线-->离线"
        },
        {
          key: "1",
          label: "离线-->在线"
        },
        {
          key: "2",
          label: "注册成功"
        }
      ],
      alarmStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "已解除"
        },
        {
          key: "1",
          label: "报警中"
        }
      ],
      deviceTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "液位报警"
        },
        {
          key: "2",
          label: "液压报警"
        },
        {
          key: "3",
          label: "烟感报警"
        },
        {
          key: "4",
          label: "温感报警"
        },
        {
          key: "5",
          label: "手动报警"
        },
        {
          key: "6",
          label: "火警"
        },
        {
          key: "7",
          label: "其他"
        }
      ],
      tableHead: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "alarmLocation",
          label: "设备位置"
        },
        {
          prop: "deviceTypeText",
          label: "报警类型"
        },
        // {
        //   prop: "numericalValue",
        //   label: "报警数值"
        // },
        {
          prop: "uploadTime",
          label: "设备报警时间"
        },
        {
          prop: "processingCycle",
          label: "报警持续时间(分钟)"
        },
        {
          prop: "alarmReleaseTime",
          label: "设备报警解除时间"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      timeValue: [],
      requestData: {
        alarmStatus: "",
        deviceType: "",
        searchKey: ""
      }
    };
  },
  created() {
    // this.permissionCodes = bus.global.permissionCodes
    // this.exportUrl = `${api.exportElectricControlDeviceStatus}?yq-app-code=${bus.global.yqCode}&kj-type=gy&searchKey=${this.requestData.searchKey}`
    this.getCurrentTime();
  },
  activated() {
    this.getCurrentTime();
  },
  methods: {
    getCurrentTime() {
      this.timeValue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timeValue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timeValue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    beforeDownload() {
      if (this.timeValue.length > 0) {
        this.exportUrl = `${
          api.exportElectricControlDeviceStatus
        }?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${
          bus.global.token
        }&searchKey=${this.requestData.searchKey}&alarmStatus=${
          this.requestData.alarmStatus
        }&startTime=${this.timeValue[0]} 00:00:00&endTime=${
          this.timeValue[1]
        } 23:59:59`;
      } else {
        this.exportUrl = `${
          api.exportElectricControlDeviceStatus
        }?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${
          bus.global.token
        }&searchKey=${this.requestData.searchKey}&alarmStatus=${
          this.requestData.alarmStatus
        }`;
      }
    },
    // 获取状态日志
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timeValue) {
        reqData.startTime = this.timeValue[0];
        reqData.endTime = this.timeValue[1];
      } else {
        reqData.startTime = "";
        reqData.endTime = "";
      }
      this.$axios
        .post(api.getFcsAlarmRecordPage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.deviceType === "1") {
              v.deviceTypeText = "液位";
            } else if (v.deviceType === "2") {
              v.deviceTypeText = "液压";
            } else if (v.deviceType === "3") {
              v.deviceTypeText = "烟感";
            } else if (v.deviceType === "4") {
              v.deviceTypeText = "温感";
            } else if (v.deviceType === "5") {
              v.deviceTypeText = "手动报警";
            } else if (v.deviceType === "6") {
              v.deviceTypeText = "火警";
            } else if (v.deviceType === "7") {
              v.deviceTypeText = "其他";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取报警记录失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    }
  }
  // watch: {
  //   timeValue (val) {
  //     this.getPage()
  //   }
  // }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/FireControl/FireControlCallPoliceRecord/FireControlCallPoliceRecord.vue